export default __webpack_public_path__ + "static/media/math-magicians1.3708d5ac.png";